import React, { useState, useEffect } from "react";
import ShopperLogin from "./ShopperLogin";
import MerchantLogin from "../merchant/MerchantLogin";

export default function Login() {
  const [mode, setMode] = useState("shopper");

  // ✅ Load saved mode on mount
  useEffect(() => {
    const saved = localStorage.getItem("veya_login_mode");
    if (saved === "merchant" || saved === "shopper") {
      setMode(saved);
    }
  }, []);

  // ✅ Persist mode when it changes
  useEffect(() => {
    localStorage.setItem("veya_login_mode", mode);
  }, [mode]);

  const switchLink = (
  <button
    type="button"
    onClick={() =>
      setMode((prev) =>
        prev === "shopper" ? "merchant" : "shopper"
      )
    }
    style={{
      background: "none",
      border: "none",
      padding: 0,
      fontSize: 13,
      color: "#5b1f2b",
      opacity: 0.75,
      cursor: "pointer",
    }}
    onMouseEnter={(e) => (e.target.style.opacity = 1)}
    onMouseLeave={(e) => (e.target.style.opacity = 0.75)}
  >
    {mode === "shopper"
      ? "Merchant login →"
      : "Shopper login →"}
  </button>
);

  return (
    <>
      {mode === "shopper" ? (
        <ShopperLogin rightAction={switchLink} />
      ) : (
        <MerchantLogin rightAction={switchLink} />
      )}
    </>
  );
}